import axios from 'axios';
import { apiBaseUrl, apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'

const getDefaultStateForSales= () => {
  return {
    sale_items_history:[],
    bom_item_price:null,
    retrieve_invoice_products: [],
    coverted_so_code:null,
    allow_qty:0,
    coverted_si_code:null,
    copied_code:null,
    sales: [],
    filter:{
      keyword:"",
      date_from:null,
      date_to:null,
      type:null,
      status:'ALL'
    },
    document_total:{
      sub_total:"",
      nett_amount:"",
      tax_amount:""
    },
    sales_subtypes:[],
    so_trade_items_for_purchase:[],
    default_sq_validity_days:null,
    generated_si_codes:[],
    sales_quotations:[],
    sales_orders:[],
    sales_invoices:[],
    document:{},
    is_created:null,
    is_updated:null,
    is_deleted:null,
    is_converted_so:null,
    is_converted_si:null,
    is_copied:null,
    is_approved:null,
    is_rejected:null,
    outstanding_sales_invoices:[],
    so_list:[],
    so_items:[],
    do_list:[]
  }
}

// state
const state = getDefaultStateForSales()

// getters
const getters = {
}
// mutations
const mutations = {
    SET_SALE_ITEMS_HISTORY(state, data) {
      state.sale_items_history = data
    },
    SET_BOM_ITEM_PRICE(state, data) {
      console.log(data)
      state.bom_item_price = data
    },
    SET_TRADE_ITEMS_FOR_PURCHASE (state, data) {
      state.so_trade_items_for_purchase = data
    },
    SET_GENERATED_SI_CODE (state, data) {
      state.generated_si_codes = data
    },
    RESET_STATE_FOR_SALES (state) {
        Object.assign(state, getDefaultStateForSales())
    },
    FETCH_OUTSTANDING_INVOICES(state, {data, type})
    {
      if(type == 'SALES')
      {
        state.outstanding_sales_invoices = data
      }
    },
    FETCH_ALL(state, { data, type })
    {
      if(data)
      {
        if(type == 'SQ')
        {
          state.sales_quotations = data
        }
        else if(type == 'SO')
        {
          state.sales_orders = data
        }
        else if(type == 'SI')
        {
          state.sales_invoices = data
        }
      }
    },
    FETCH(state, data) {
      if(data)
      {
        state.document = data

      }
    },
    SET_ALLOW_QTY(state, data)
    {
      state.allow_qty = data
    },
    SET_IS_CREATED(state, data)
    {
      state.is_created = data
    },
    SET_IS_UPDATED(state, data)
    {
      state.is_updated = data
    },
    SET_FILTER(state, data)
    {
      state.filter = data
    },
    RETRIEVE_INVOICE_PRODUCTS(state, data) {
      state.retrieve_invoice_products = data.items
    },
    SET_IS_COPIED(state, data){
      state.is_copied = data.is_copied
      state.copied_code = data.code
    },
    SET_SO_CONVERTED(state, data) {
      state.is_converted_so = data.is_converted
      state.coverted_so_code = data.code
    },
    SET_SI_CONVERTED(state, data) {
      state.is_converted_si = data.is_converted
      state.coverted_si_code = data.code
    },
    SET_IS_APPROVED (state, data) {
      state.is_approved = data
    },
    SET_IS_REJECTED (state, data) {
      state.is_rejected = data
    },
    SET_SO_LISTS_FOR_DO(state, data){
      state.so_list = data
    },
    SET_DO_LISTS_FOR_SI(state, data){
      if(data)
      {
        data.forEach(function(element) {
            element._showDetails =  true
        });
        state.do_list = data

      }
    },
    SET_SO_ITEMS(state, data){
      data.forEach(function(element) {
          element.qty =  element.qty
      });
      state.so_items = data
    },
    SET_DEFAULT_SQ_VALIDITY_DAYS(state, data) {
      state.default_sq_validity_days = data
    },
    SET_SALES_SUBTYPES(state, data){
      state.sales_subtypes = data
    },
    SET_DOCUMENT_TOTAL(state, data){
      state.document_total = data
    }
}
// actions
const actions = 
{
  async cal_document_total({ commit }, data)
  {
    return axios.post(apiRoutes['CAL_SALES_DOCUMENT_TOTAL'], data, authHeader())
    .then(response => 
    {
        if(response.data.code == 1)
        {
          commit('SET_DOCUMENT_TOTAL', response.data.data)
        } 
        else 
        {
          commit('SET_DOCUMENT_TOTAL', {})
        }
    })
    .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
  },
  getSalesSubTypes({ commit }, data) 
  {
      return axios.post(apiRoutes['GET_SALES_SUBTYPES'], data, authHeader())
          .then(response => {
            if(response.data.code == 1){
              commit('SET_SALES_SUBTYPES', response.data.data)
            } else {
              commit('SET_SALES_SUBTYPES', [])
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
  resetState({ commit, dispatch }, payload) {
    commit("RESET_STATE_FOR_SALES")
  },
  setDoList({commit}, data){
    commit('SET_DO_LISTS_FOR_SI', [])
  },
  setInvoiceProducts({commit}, data){
    commit('RETRIEVE_INVOICE_PRODUCTS', data)
  },
  validateSoQtyForDo({commit}, data) {
      return axios.post(apiRoutes['VALIDATE_ALLOCATE_QTY_FOR_DO'], data, authHeader())
      .then(response => {
          if (response.data.code == 1) 
          {
            commit('SET_ALLOW_QTY', response.data.data.allow_qty)
          } 
          else 
          {
            commit('SET_ALLOW_QTY', 0)
          }
      })
      .catch(error => {
          commit('SET_ALLOW_QTY', 0)
          if (error.response) {
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
    });
  },
  generateInvoiceFromDo({ commit }, data) {
    return axios.post(apiRoutes['GENERATE_INVOICE_FROM_DOS'], data, authHeader())
        .then(response => {
            if (response.data.code == 1) 
            {
              commit('SET_GENERATED_SI_CODE', response.data.data.invoices)
            } 
            else 
            {
              commit('SET_GENERATED_SI_CODE', [])
            }
        })
        .catch(error => {
            if (error.response) {
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
      });
  },
  approveDocuments({ commit }, data) {
    return axios.post(apiRoutes['APPROVE_DOCUMENTS'], data, authHeader())
        .then(response => {
            if (response.data.code == 1) 
            {
                commit('SET_IS_APPROVED', 1)
                Vue.notify({
                    group: 'notify',
                    type: 'success',
                    text: response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } 
            else 
            {
              commit('SET_IS_APPROVED', 0)
            }
        })
        .catch(error => {
            if (error.response) {
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
  rejectDocuments({ commit }, data) {
    return axios.post(apiRoutes['REJECT_DOCUMENTS'], data, authHeader())
        .then(response => {
            if (response.data.code == 1) 
            {
                commit('SET_IS_REJECTED', 1)
                Vue.notify({
                    group: 'notify',
                    type: 'success',
                    text: response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } 
            else 
            {
              commit('SET_IS_REJECTED', 0)
            }
        })
        .catch(error => {
            commit('SET_IS_REJECTED', 0)
            if (error.response) {
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
  approveDocument({ commit }, data) {
      return axios.post(apiRoutes['APPROVE_DOCUMENT'], data, authHeader())
          .then(response => {
              if (response.data.code == 1) 
              {
                commit('SET_IS_APPROVED', 1)
                let doc_number  = response.data.data.code
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'Sales (' + doc_number + ')' + " has been approved!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } 
              else 
              {
                commit('SET_IS_APPROVED', 0)
              }
          })
          .catch(error => {
              if (error.response) {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
  },
  rejectDocument({ commit }, data) {
    return axios.post(apiRoutes['REJECT_DOCUMENT'], data, authHeader())
        .then(response => {
            if (response.data.code == 1) 
            {
              commit('SET_IS_REJECTED', 1)
              let doc_number  = response.data.data.code
                Vue.notify({
                    group: 'notify',
                    type: 'success',
                    text: 'Sales (' + doc_number + ')' + " has been rejected!",
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } 
            else 
            {
              commit('SET_IS_REJECTED', 0)
            }
        })
        .catch(error => {
            if (error.response) {
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
},
  retrieveInvoiceItems({ commit }, data) {
      return axios.post(apiRoutes['RETRIEVE_INVOICE'], data, authHeader())
          .then(response => {
              if (response.data.code == 1) 
              {
                  commit('RETRIEVE_INVOICE_PRODUCTS', response.data.data)
              } 
              else 
              {
                  commit('RETRIEVE_INVOICE_PRODUCTS', {})
              }
          })
          .catch(error => {
              if (error.response) {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
  },
  retrieveOutstandingInvoices({ commit }, data) {
      let apiUrl = null
      if(data.type == 'SALES')
      {
        apiUrl = apiRoutes['RETRIEVE_OUTSTANDING_SIS'];
      }
      if(apiUrl)
      {
        return axios.post(apiUrl, data, authHeader())
        .then(response => {
            if (response.data.code == 1) 
            {
              commit('FETCH_OUTSTANDING_INVOICES', {data:response.data.data, type:data.type})
            } 
            else 
            {
              commit('FETCH_OUTSTANDING_INVOICES', {})
            }
        })
        .catch(error => {
            if (error.response) {
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
      }

  },
  fetchSaleItemsHistoryForCustomer({ commit }, data) {
    return axios.post(apiRoutes['GET_SALES_ITEMS_HISTORY_FOR_CUSTOMER'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('SET_SALE_ITEMS_HISTORY', response.data.data)
          } 
          else 
          {
            commit('SET_SALE_ITEMS_HISTORY', [])
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
  },
  fetchTradeSoItemsForPO({ commit }, data) {
    return axios.post(apiRoutes['GET_TRADE_ITEMS_FOR_PURCHASE'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('SET_TRADE_ITEMS_FOR_PURCHASE', response.data.data)
          } 
          else 
          {
            commit('SET_TRADE_ITEMS_FOR_PURCHASE', [])
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
  },
  fetchDosForSI({ commit }, data) {
    return axios.post(apiRoutes['LIST_DOS_FOR_SI'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('SET_DO_LISTS_FOR_SI', response.data.data)
          } 
          else 
          {
            commit('SET_DO_LISTS_FOR_SI', [])
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
  },
  fetchSosForDo({ commit }, data) {
    return axios.post(apiRoutes['LIST_SO_FOR_DO'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('SET_SO_LISTS_FOR_DO', response.data.data)
          } 
          else 
          {
            commit('SET_SO_LISTS_FOR_DO', [])
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
  },
  fetchSoItems({ commit }, data) {
    return axios.post(apiRoutes['RETRIEVE_SO_ITEMS'], data, authHeader())
        .then(response => {
          if(response.data.code == 1)
          {
            commit('SET_SO_ITEMS', response.data.data)
          } 
          else 
          {
            commit('SET_SO_ITEMS', [])
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response)
              Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: error.response.data.msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
          } else {
              console.log("Problem Querying Data!", error);
          }
      });
  },
  // Main
  quickSearch({ commit }, data) {
        return axios.post(apiRoutes['SALES_QUICK_SEARCH'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('FETCH_ALL', {data:response.data.data, type:data.type})
                commit('SET_FILTER', data)
              } 
              else 
              {
                commit('FETCH_ALL', {data:[], type:null})
                commit('SET_FILTER', data)
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
  },
  getDefaultSqValidityDays({ commit }, data) {
      return axios.post(apiRoutes['DEFAULT_SQ_VALIDITY_DAYS'], data, authHeader())
          .then(response => {
            if(response.data.code == 1){
              commit('SET_DEFAULT_SQ_VALIDITY_DAYS', response.data.data)
            } else {
              commit('SET_DEFAULT_SQ_VALIDITY_DAYS', null)
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
  getBomItemPrice({ commit }, data) {
    let apiUrl = apiRoutes['GET_BOM_ITEM_PRICE'];

      return axios.post(apiUrl, data, authHeader())
          .then(response => {
            if(response.data.code == 1){
              commit('SET_BOM_ITEM_PRICE', response.data.data.recommended_unit_price)
            } else {
              commit('SET_BOM_ITEM_PRICE', null)
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
  fetch({ commit }, data) {
    let apiUrl = null;
      if(data.type == 'SQ')
      {
        apiUrl = apiRoutes['SALES_RETRIEVE_QUOTATION']
      }
      else if(data.type == 'SO')
      {
        apiUrl = apiRoutes['SALES_RETRIEVE_ORDER']
      } 
      else if(data.type == 'SI')
      {
        apiUrl = apiRoutes['SALES_RETRIEVE_INVOICE']
      }
      return axios.post(apiUrl, data, authHeader())
          .then(response => {
            if(response.data.code == 1){
              commit('FETCH', response.data.data)
            } else {
              commit('FETCH', {})
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  },
  async create({ commit, dispatch }, data) {
    let apiCreateSaleDocument  = '';
    if(data['type'] == 'SQ')
      apiCreateSaleDocument = apiRoutes['CREATE_SALE_QUOTATION']
    else if(data['type'] == 'SO')
      apiCreateSaleDocument = apiRoutes['CREATE_SALE_ORDER']
    else if(data['type'] == 'SI')
      apiCreateSaleDocument = apiRoutes['CREATE_SALE_INVOICE']

    await axios.post(apiCreateSaleDocument, data, authHeader())
        .then(function (response) {
          if(response.data.code == 1)
          {
            let doc_number  = response.data.data.code

            if (response.data.data.is_approved == null)
            {
              Vue.notify({
                  group: 'notify',
                  type: 'warn',
                  text: 'Sales (' + doc_number + ')' + " sent for approval!",
                  max: 5,
                  duration: 10000,
                  speed: 300
              })
            }
            else
            {
              Vue.notify({
                  group: 'notify',
                  type: 'success',
                  text: 'Sales (' + doc_number + ')' + " has been created!",
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
            }

            commit('SET_IS_CREATED', 1);
          }
          else
          {
              let errors = response.data.data.errors
                  
              if(Array.isArray(errors))
              {
                let msg = errors.join("\n")
                Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
              }
              commit('SET_IS_CREATED', 0);
          }

        })
        .catch((error) => {
            // alert(error)
            // console.log(error.response)

            if (error.response) {
                //alert(error.response.data.message)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.message,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            }
            else
            {
                //console.log("Problem submitting New Post", error);
                alert("Application Error")
            }
        });
  },
  async update({ commit, dispatch }, data) 
  {
    let apiUrl  = '';
    if(data['type'] == 'SQ')
      apiUrl = apiRoutes['UPDATE_SALE_QUOTATION']
    else if(data['type'] == 'SO')
      apiUrl = apiRoutes['UPDATE_SALE_ORDER']
    else if(data['type'] == 'SI')
      apiUrl = apiRoutes['UPDATE_SALE_INVOICE']

    await axios.post(apiUrl, data, authHeader()).then(function (response) {
          if(response.data.code == 1)
          {
            let doc_number  = response.data.data.code
            Vue.notify({
              text: 'Sales (' + doc_number + ')' + " has been updated!",
              type: 'success', group: 'notify', max: 5, duration: 5000, speed: 300})

            commit('SET_IS_UPDATED', 1);
          }
          else
          {
            if (response.data.data.errors)
            {
              let errors = response.data.data.errors
              if(Array.isArray(errors))
              {
                let msg = errors.join("\n")
                Vue.notify({text: msg, type: 'error', group: 'notify', max: 5, duration: 5000, speed: 300})
              }
            }
            commit('SET_IS_UPDATED', 0);
          }
        })
        .catch((error) => {
            if (error.response) {
                //alert(error.response.data.message)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.message,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            }
            else
            {
                Vue.notify({text: 'Server Interface Error', type: 'error', group: 'notify', max: 5, duration: 5000, speed: 300})
            }
        });
  },
  async copy({ commit, dispatch }, data) {
    await axios.post(apiRoutes['COPY_DOCUMENT'], data, authHeader()).then(function (response) {
          if(response.data.code == 1)
          {
            let doc_number  = response.data.data.code
            Vue.notify({
                group: 'notify',
                type: 'success',
                text: 'Sales document has been copied to (' + doc_number + ')!',
                max: 5,
                duration: 5000,
                speed: 300
            })
            commit('SET_IS_COPIED', {is_copied: 1, code:doc_number});
          }
          else
          {
              let errors = response.data.data.errors
                  
              if(Array.isArray(errors))
              {
                let msg = errors.join("\n")
                Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
              }
              commit('SET_IS_COPIED', {is_copied: 1, code:null});
            }
        })
        .catch((error) => {
            if (error.response) {
                //alert(error.response.data.message)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.message,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            }
            else
            {
                //console.log("Problem submitting New Post", error);
                alert("Application Error")
            }
        });
  },
  async convertToSO({ commit, dispatch }, data) {
    await axios.post(apiRoutes['CONVERT_TO_SO'], data, authHeader()).then(function (response) {
          if(response.data.code == 1)
          {
            let doc_number  = response.data.data.code
            Vue.notify({
                group: 'notify',
                type: 'success',
                text: 'Sales (' + doc_number + ')' + " has been created!",
                max: 5,
                duration: 5000,
                speed: 300
            })
            commit('SET_SO_CONVERTED', {is_converted: 1, code:doc_number});
          }
          else
          {
              let errors = response.data.data.errors
                  
              if(Array.isArray(errors))
              {
                let msg = errors.join("\n")
                Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
              }
              commit('SET_SO_CONVERTED', {is_converted: 0, code:null});
            }
        })
        .catch((error) => {
            if (error.response) {
                //alert(error.response.data.message)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.message,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            }
            else
            {
                //console.log("Problem submitting New Post", error);
                alert("Application Error")
            }
        });
  },
  async convertToSI({ commit, dispatch }, data) {
    await axios.post(apiRoutes['CONVERT_TO_SI'], data, authHeader()).then(function (response) {
          if(response.data.code == 1)
          {
            let doc_number  = response.data.data.code
            Vue.notify({
                group: 'notify',
                type: 'success',
                text: 'Sales (' + doc_number + ')' + " has been created!",
                max: 5,
                duration: 5000,
                speed: 300
            })
            commit('SET_SI_CONVERTED', {is_converted: 1, code:doc_number});
          }
          else
          {
              let errors = response.data.data.errors
                  
              if(Array.isArray(errors))
              {
                let msg = errors.join("\n")
                Vue.notify({
                  group: 'notify',
                  type: 'error',
                  text: msg,
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
              }
              commit('SET_SI_CONVERTED', {is_converted: 0, code:null});
            }
        })
        .catch((error) => {
            if (error.response) {
                //alert(error.response.data.message)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.message,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            }
            else
            {
                //console.log("Problem submitting New Post", error);
                alert("Application Error")
            }
        });
  },
}

export {
    state,
    getters,
    actions,
    mutations
}
